export default "__VITE_ASSET__BM__rc$e__"